import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Particle from "../Particle";
import AnimatedSection from "../AnimatedSection";
import pdf from "../../Assets/../Assets/Aftab-Resume.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container className="resume-inner">
        <AnimatedSection>
          <div className="resume-header">
            <div className="resume-header-text">
              <h1 className="project-heading resume-page-title">
                My <span className="purple">Resume</span>
              </h1>
              <p className="section-subtitle resume-page-subtitle">
                Preview my experience below or download a copy.
              </p>
            </div>
            <a
              href={pdf}
              download="Aftab-Resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-download"
            >
              <AiOutlineDownload />
              Download CV
            </a>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.15}>
          <Row className="resume">
            <div className="pdf-viewer-wrapper d-flex justify-content-center w-100">
              <Document file={pdf} className="d-flex justify-content-center">
                <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.6} />
              </Document>
            </div>
          </Row>
        </AnimatedSection>

        <AnimatedSection delay={0.25}>
          <div className="resume-download-footer">
            <a
              href={pdf}
              download="Aftab-Resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-download btn-download-outline"
            >
              <AiOutlineDownload />
              Download CV
            </a>
          </div>
        </AnimatedSection>
      </Container>
    </Container>
  );
}

export default ResumeNew;
